<div class="container">
  <div class="close-button d-flex justify-content-end mb-3">
    <button (click)="close()" type="button" class="btn">
      <span class="material-symbols-outlined"> close </span>
    </button>
  </div>
  <p class="title">Input the below details to continue booking</p>

  @if (errorMessage) {
    <div class="error-div mb-3">
      <span>
        {{ errorMessage }}
      </span>
    </div>
  }

  <form autocomplete="false" novalidate role="form" [formGroup]="loginForm">
    <div class="form-row">
      <div>
        <div class="form-floating">
          <input
            autocomplete="off"
            formControlName="email"
            placeholder="Email Address"
            class="form-control"
            type="email"
            />
          <label>Email Address</label>
        </div>
      </div>
      <div>
        <div class="input-group">
          <div class="form-floating">
            <input
              autocomplete="new-password"
              formControlName="password"
              placeholder="Choose Password"
              class="form-control"
              type="{{ hide ? 'password' : 'text' }}"
              />
            <label>Password</label>
          </div>
          <span (click)="hide = !hide" class="input-group-text">
            <span class="material-symbols-outlined">
              {{ hide ? "visibility" : "visibility_off" }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <a (click)="onForgotPassword()" class="d-block text-end forgot_password">
      Forgot Password ?
    </a>

    <!-- <div class="d-flex justify-content-center mt-3">
    <re-captcha
      [siteKey]="recaptchaSiteKey"
      (resolved)="onCaptchaResolved($event)"
      >
    </re-captcha>
  </div> -->

  <button
    [disabled]="isLoading"
    (click)="onLogin()"
    type="button"
    class="mx-auto btn prjct-btn mt-5"
    >
    Enter
  </button>
  <p class="form-text text-center">
    Don't have an account?
    <a (click)="onRegister()" class="forgot_password"> Click to Register </a>
  </p>
</form>
</div>
